{
  "RESET_PASSWORD": {
    "TITLE": "Сбросить пароль",
    "DESCRIPTION": "Введите адрес электронной почты, который вы используете для входа в Чатвут, чтобы получить инструкции по сбросу пароля.",
    "GO_BACK_TO_LOGIN": "Если вы хотите вернуться на страницу входа",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "Пожалуйста, введите ваш email.",
      "ERROR": "Пожалуйста, введите правильный email."
    },
    "API": {
      "SUCCESS_MESSAGE": "Ссылка для сброса пароля была отправлена на ваш email.",
      "ERROR_MESSAGE": "Не удалось подключиться к Woot серверу. Пожалуйста, попробуйте еще раз."
    },
    "SUBMIT": "Отправить"
  }
}
